import { Component, Input, OnInit } from '@angular/core';
import { AbstractControl, FormControl, FormGroup, ValidationErrors, Validators } from '@angular/forms';
import { MatDialog } from '@angular/material/dialog';
import { DialogexComponent } from '../dialogex/dialogex.component';
import { PaymentService } from 'src/app/_services/payment.service';
import { ActivatedRoute, Router } from '@angular/router';
import { LoginService } from 'src/app/_services/login.service';
import { AuthService } from 'src/app/_services/auth.service';
import { AlertService } from 'src/app/_alert';
import { ConfirPopUpComponent } from '../popup/confir-pop-up/confir-pop-up.component';
import { environment } from 'src/environments/environment';
import { AppServiceService } from 'src/app/_services/app-service.service';
import * as countrycitystatejson from 'countrycitystatejson';
import { CreditCardService } from 'src/app/_services/credit-card.service';
import { ZipCodeService } from 'src/app/_services/zip-code.service';

interface Country {
  shortName: string;
  name: string;
}

@Component({
  selector: 'app-payment-link',
  templateUrl: './payment-link.component.html',
  styleUrls: ['./payment-link.component.css']
})
export class PaymentLinkComponent implements OnInit {
  receivedId: number;
  decryptedUrl: string;
  submitted: boolean = true;
  serviceName: string;
  serviceCharge: any;
  serviceD: any;
  transactionPaymentId: any;
  imageServerPath: string;
  logoFile: any;
  options = {
    autoClose: true,
    keepAfterRouteChange: true,
  };
  paymentEntryVerbiage: any;
  countries: Country[];
  states: any[];
  cities: string[];
  private countryData = countrycitystatejson;
  hide = true;
  validationMessage: string = '';
  isCreditCardValid: boolean = false;

  ngOnInit(): void {
    // if (this.billingSetupForm.value.country) {
    //   this.states = this.getStatesByCountry(this.billingSetupForm.value.country);
    //   console.log(this.states)
    //   this.billingSetupForm.get('billingState').enable();
    // }
    this.initialIdleSettings();
    this.route.queryParams.subscribe((response) => {
      var responseid = response.id.split(' ').join('+');
      var qs = responseid + "|" + response.at;
      console.log('at',response.at);
      this.paymentService.getNewToken(response.at).subscribe((toknResp)=>{
        this.loginService.details(toknResp.token).subscribe((res) => {
          console.log('detail',res)
          this.paymentEntryVerbiage = res['paymentEntryVerbiage'];
        })
        sessionStorage.setItem('PaymentToken', toknResp.token);
        this.partyDetails();
        this.paymentService.paymentReqQstring(qs).subscribe((rtnstr: any) => {
          rtnstr = rtnstr['data'];
          var elmt = rtnstr.split('|');
          var ctkn = elmt[1];
          console.log('ccct', ctkn)
          var reqrecid = elmt[0];
          switch (ctkn) {
            case 'processed':
              this.router.navigate(['/processed']);
              break;
            case 'canceled':
              this.router.navigate(['/cancelled']);
              break;
            case 'maxattempts':
              this.router.navigate(['/maxAttempts']);
              break;
            case 'expired':
              this.router.navigate(['/expired']);
              break;
            default:
              this.readData(reqrecid, ctkn);
              break;
          }
        }, (err) => {
          //debugger;
          this.router.navigate(['/error']);
          console.log(err);
        })
      }, (toknErr) => {
        //debugger;
        this.router.navigate(['/error']);
        console.log(toknErr);
      })
      
    })
  }

  // onStateClick(event) {
  //   var state = event.value;
  //   console.log("statee", state);
  //   if (state) {
  //     this.cities = this.getCitiesByState(this.billingSetupForm.value.country, state);
  //     console.log(this.cities)
  //     this.billingSetupForm.get('billingCity').enable();
  //   }
  // }

  constructor(public dialog: MatDialog,
    private paymentService: PaymentService,
    private route: ActivatedRoute,
    private loginService: LoginService,
    private authService: AuthService,
    private alertService: AlertService,
    private router: Router,
    private zipCodeService : ZipCodeService,
    private creditCardService: CreditCardService,
    private appService: AppServiceService
  ) { }

  openDialog() {
    const dialogRef = this.dialog.open(DialogexComponent);
    dialogRef.afterClosed().subscribe(result => {
      console.log(`Dialog result: ${result}`);
    });
  }

  public createImgPath = (serverPath: string) => {
    if (serverPath == null || serverPath == '' || serverPath == undefined) {
      return "../../../assets/images/final automated.png";
    }
    return environment.BaseApiUrl + `/Customer/image?fileName=${serverPath}`;
  }

  billingSetupForm: FormGroup = new FormGroup(
    {
      country: new FormControl('US'),
      BillingSuit: new FormControl(''),
      paymentRequestId: new FormControl(''),
      customerId: new FormControl(''),
      custTrackingNo: new FormControl(''),
      partyId: new FormControl(''),
      recurringFlag: new FormControl(''),
      product: new FormControl(''),
      chargeAmt: new FormControl(''),
      paymentType: new FormControl(''),
      paymentAmount: new FormControl(''),
      ccType: new FormControl(''),
      ccNumber: new FormControl('',
        [Validators.required,
        Validators.maxLength(16),
        Validators.minLength(15),
        ]),
      ccExpYear: new FormControl('',
        [Validators.required]),
      ccExpMonth: new FormControl('',
        [Validators.required]),
      csc: new FormControl('',
        [Validators.required,
        Validators.maxLength(3)]),
      ccName: new FormControl('', [Validators.required]),
      ccZip: new FormControl(''),
      ccPhone: new FormControl(''),
      ccEmail: new FormControl(''),
      acctHolderName: new FormControl(''),
      bankName: new FormControl(''),
      bankAddress: new FormControl(''),
      abaBankRoutingNbr: new FormControl(''),
      bankAccountNumber: new FormControl(''),
      bankAccountType: new FormControl(''),
      achAuthType: new FormControl(''),
      achComment: new FormControl(''),
      achDescriptor: new FormControl(''),
      billingNameFirst: new FormControl('', [
        Validators.required,
        Validators.minLength(2)]),
      billingNameLast: new FormControl('', [
        Validators.required,
        Validators.minLength(2)]
      ),
      billingAddrLine1: new FormControl('',
        [
          Validators.required,
          Validators.minLength(2)
        ]),
      billingAddrLine2: new FormControl(''),
      billingCity: new FormControl('', [
        Validators.required,
      ]),
      billingState: new FormControl('',
        [
          Validators.required,
          //Validators.minLength(2)
        ]),
      billingZipCode: new FormControl('', [
        Validators.required,
        Validators.minLength(5),
        Validators.maxLength(5)
      ]),
      billingPhoneType: new FormControl(''),
      billingPhoneNumber: new FormControl('', [
        Validators.required,
        Validators.pattern('^(\([0-9]{3}\)|[0-9]{3}-)[0-9]{3}-[0-9]{4}$')
      ]),
      billingEmail: new FormControl('', [
        Validators.required,
        Validators.email,
        Validators.pattern("^[a-z0-9._%+-]+@[a-z0-9.-]+\\.[a-z]{2,4}$")
      ]),
      logRecId: new FormControl(''),
      CreateDate: new FormControl(new Date()),
      LastUpdateDate: new FormControl(new Date())
    }
  )

  get forms() {
    return this.billingSetupForm.controls;
  }

  validateExpirationDate(control: FormControl): { [key: string]: boolean } | null {
    const value = control.value;
    if (value && !/^(0[1-9]|1[0-2])\/\d{2}$/.test(value)) {
      return { 'invalidExpirationDate': true };
    }
    return null;
  }

  onSubmit() {
    this.submitted = true;
    if (this.billingSetupForm.valid) {
      console.log(this.billingSetupForm.value)
    }
    else {
      console.log('Please enter valid data!');
      this.alertService.error('Error!! Please Enter valid data.', this.options);
    }
  }

  onConfirm() {
    this.billingSetupForm.markAllAsTouched();
    this.submitted = true;
    if (this.billingSetupForm.valid) {
      console.log("billing : ", this.billingSetupForm.value);
      this.openConfirmDialog();
    }
    else {
      this.alertService.error('Error!! Please Enter valid data.', this.options);
    }
  }

  openConfirmDialog(): void {
    const dialogRef = this.dialog.open(ConfirPopUpComponent, {
      width: '500px',
      disableClose: true,
      data:
      {
        paymentRequestId: this.billingSetupForm.value.paymentRequestId,
        customerId: this.billingSetupForm.value.customerId,
        custTrackingNo: this.billingSetupForm.value.custTrackingNo,
        partyId: this.billingSetupForm.value.partyId,
        recurringFlag: this.billingSetupForm.value.recurringFlag,
        product: this.billingSetupForm.value.product,
        chargeAmt: this.billingSetupForm.value.chargeAmt,
        paymentType: this.billingSetupForm.value.paymentType,
        paymentAmount: this.billingSetupForm.value.paymentAmount,
        ccType: this.billingSetupForm.value.ccType,
        ccNumber: this.billingSetupForm.value.ccNumber,
        ccExpYear: this.billingSetupForm.value.ccExpYear,
        ccExpMonth: this.billingSetupForm.value.ccExpMonth,
        csc: this.billingSetupForm.value.csc,
        ccName: this.billingSetupForm.value.ccName,
        ccZip: this.billingSetupForm.value.ccZip,
        ccPhone: this.billingSetupForm.value.ccPhone,
        ccEmail: this.billingSetupForm.value.ccEmail,
        acctHolderName: this.billingSetupForm.value.acctHolderName,
        bankName: this.billingSetupForm.value.bankName,
        bankAddress: this.billingSetupForm.value.bankAddress,
        abaBankRoutingNbr: this.billingSetupForm.value.abaBankRoutingNbr,
        bankAccountNumber: this.billingSetupForm.value.bankAccountNumber,
        bankAccountType: this.billingSetupForm.value.bankAccountType,
        achAuthType: this.billingSetupForm.value.achAuthType,
        achComment: this.billingSetupForm.value.achComment,
        achDescriptor: this.billingSetupForm.value.achDescriptor,
        billingNameFirst: this.billingSetupForm.value.billingNameFirst,
        billingNameLast: this.billingSetupForm.value.billingNameLast,
        billingAddrLine1: this.billingSetupForm.value.billingAddrLine1,
        billingAddrLine2: this.billingSetupForm.value.billingAddrLine2,
        billingCity: this.billingSetupForm.value.billingCity,
        billingState: this.billingSetupForm.value.billingState,
        billingZipCode: this.billingSetupForm.value.billingZipCode,
        billingPhoneType: this.billingSetupForm.value.billingPhoneType,
        billingPhoneNumber: this.billingSetupForm.value.billingPhoneNumber,
        billingEmail: this.billingSetupForm.value.billingEmail,
        logRecId: this.billingSetupForm.value.logRecId
      }
    });
  }

  partyDetails() {
    var token = sessionStorage.getItem('PaymentToken');
    this.loginService.details(token).subscribe((response) => {
      console.log(response);
      this.logoFile = response['logoFile'];
      if (this.logoFile == null || this.logoFile == '' || this.logoFile == undefined) {
        sessionStorage.setItem('logoFile', '');
      }
      else {
        sessionStorage.setItem('logoFile', this.logoFile);
      }
    })
  }

  validateInput(event: any) {
    const input = event.target as HTMLInputElement;
    const inputValue = input.value;
    const restrictedValue = inputValue.slice(0, 3);
    input.value = restrictedValue;
    this.billingSetupForm.value.csc = restrictedValue;
  }

  onPressCCNum(event) {
    const inputValue = event.target.value;
    const maxDigits = 16;
    if (event.target.value.length > 16) {
      const truncatedValue = inputValue?.slice(0, maxDigits);
      event.target.value = truncatedValue;
      this.billingSetupForm.value.ccNumber = event.target.value
    }
  }

  //session
  private initialIdleSettings() {
    const idleTimeoutInSeconds: number = environment.idleTimeInMinutes * 60;
    this.appService.startWatching(idleTimeoutInSeconds).subscribe((isTimeOut: boolean) => {
      if (isTimeOut) {
        // alert("Session timeout. It will redirect to login page.");
        this.openPopup();
      }
    });
  }

  displayStyle = "none";

  openPopup() {
    this.displayStyle = "block";
  }

  closePopup() {
    this.displayStyle = "none";
    this.router.navigate(['/sessionTimeout']);
  }

  getCountries() {
    return this.countryData.getCountries();
  }

  getStatesByCountry(countryShotName: string) {
    return this.countryData.getStatesByShort(countryShotName);
  }

  getCitiesByState(country: any, state: any) {
    return this.countryData.getCities(country, state);
  }

  readData(reqrecid: any, token: any) {
    //debugger;
    this.paymentService.paymentReqDetailsToken(reqrecid, token).subscribe((result: any) => {
      console.log("after call : ", result);
      this.serviceName = result['serviceCode'];
      this.serviceCharge = result['serviceCharge'];
      this.serviceD = result['serviceDescription'];
      // var event = {};
      // event['value'] = result['payeeState'];
      // this.onStateClick(event);
      // debugger;
      const mockEvent = {
        target: { value: result['payeeZip'], }
      }
      this.onZipCodeChange(mockEvent);
      this.billingSetupForm = new FormGroup(
        {
          billingNameFirst: new FormControl(result['payeeNameFirst'],
            [Validators.required,
            Validators.minLength(2)]),
          billingEmail: new FormControl(result['payeeEmail'],
            [Validators.required,
            Validators.email,
            Validators.pattern("^[a-z0-9._%+-]+@[a-z0-9.-]+\\.[a-z]{2,4}$")]),
          billingAddrLine1: new FormControl(result['payeeAddress'],
            [Validators.required,
            Validators.minLength(2)]),
          country: new FormControl('US'),
          billingCity: new FormControl(result['payeeCity'],
            [Validators.required,
            Validators.minLength(2)]),
          billingNameLast: new FormControl(result['payeeNameLast'],
            [Validators.required,
            Validators.minLength(2)]),
          billingPhoneNumber: new FormControl(result['payeePhone'],
            [Validators.required,
            Validators.pattern('^(\([0-9]{3}\)|[0-9]{3}-)[0-9]{3}-[0-9]{4}$')]),
          BillingSuit: new FormControl(''),
          billingState: new FormControl(result['payeeState'],
            [Validators.required]),
          billingZipCode: new FormControl(result['payeeZip'],
            [Validators.required,
            Validators.minLength(5),
            Validators.maxLength(7)]),
          paymentRequestId: new FormControl(result['paymentRequestId']),
          customerId: new FormControl(result['customerId']),
          custTrackingNo: new FormControl(result['custTrackingNo']),
          partyId: new FormControl(result['partyId']),
          recurringFlag: new FormControl('0'),
          product: new FormControl(result['serviceDescription']),
          chargeAmt: new FormControl(result['serviceCharge']),
          paymentType: new FormControl('1'),
          paymentAmount: new FormControl(result['serviceCharge']),
          ccType: new FormControl(''),
          ccNumber: new FormControl('',
            [Validators.required,
            Validators.maxLength(16),
            Validators.minLength(16)]),
          ccExpYear: new FormControl('',
            [Validators.required]),
          ccExpMonth: new FormControl('', [Validators.required]),
          csc: new FormControl('', [Validators.required]),
          ccName: new FormControl('', [Validators.required]),
          ccZip: new FormControl(result['payeeZip']),
          ccPhone: new FormControl(result['payeePhone']),
          ccEmail: new FormControl(result['payeeEmail']),
          acctHolderName: new FormControl(''),
          bankName: new FormControl(''),
          bankAddress: new FormControl(''),
          abaBankRoutingNbr: new FormControl(''),
          bankAccountNumber: new FormControl(''),
          bankAccountType: new FormControl(''),
          achAuthType: new FormControl('WEB'),
          achComment: new FormControl(''),
          achDescriptor: new FormControl(''),
          billingAddrLine2: new FormControl(result['payeeAddress']),
          billingPhoneType: new FormControl(''),
          logRecId: new FormControl(result['paymentRequestId']),
          CreateDate: new FormControl(new Date()),
          LastUpdateDate: new FormControl(new Date())
        }
      )
    }, (err) => {
      console.log(err);
      // if (err.error.errors.Messages[0] = "processed") {
      //   this.router.navigate(['/processed']);
      // }
      // if (err.error.errors.Messages[0] = "expired") {
      //   this.router.navigate(['/expired']);
      // }
    })
  }

  onCardNumberChange() {
    this.billingSetupForm.value.ccType = this.creditCardService.validateCardType(this.billingSetupForm.value.ccNumber);
    console.log(this.billingSetupForm.value.ccType);
  }

  //valid credit card num
  validateCreditCard() {
    const cleanedNumber = this.billingSetupForm.value.ccNumber.replace(/\D/g, '');
    this.isCreditCardValid = this.isValidCreditCard(cleanedNumber);
    if (this.isValidCreditCard(cleanedNumber)) {
      this.validationMessage = ' ';
    } else {
      this.validationMessage = 'Invalid credit card number ';
    }
  }

  isValidCreditCard(cardNumber: string): boolean {
    const reversedNumber = cardNumber.split('').reverse().map(Number);
    let sum = 0;
    for (let i = 0; i < reversedNumber.length; i++) {
      let digit = reversedNumber[i];
      if (i % 2 !== 0) {
        digit *= 2;
        if (digit > 9) {
          digit -= 9;
        }
      }
      sum += digit;
    }
    return sum % 10 === 0;
  }

  onPress(event) {
    const inputValue = event.target.value;
    const maxDigits = 11;
    if (event.target.value.length > 11) {
      const truncatedValue = inputValue?.slice(0, maxDigits);
      event.target.value = truncatedValue;
      this.billingSetupForm.value.billingPhoneNumber = event.target.value
    }
  }

  onCreditPress(event) {
    const inputValue = event.target.value;
    const maxDigits = 15;
    if (event.target.value.length > 15) {
      const truncatedValue = inputValue?.slice(0, maxDigits);
      event.target.value = truncatedValue;
      this.billingSetupForm.value.ccNumber = event.target.value
    }
  }

  onZipCodeChange(event) {
    var zip = event.target.value;
    this.cities = [];
    this.states = [];
    if (zip == null || zip.length == 0 || zip.length < 5)
      return;
    this.zipCodeService.getDetailByZipPayment(zip).subscribe((data: any) => {
      console.log(data);
      if (data == null) {
        return;
      }
      this.cities = data.places.map((place: any) => place['city']);
      this.states = data.places.map((place: any) =>  place['state']);
    });
  }
}




